import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { queueMobx } from 'restaurant'
import { queueOrderingMobx } from '@mobxStore'
import { ddayjs } from '@dt/fe-utils'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  scene?: 'menu' | 'checkout';
}

const toM = (n: number) => {
  return n >= 0 && n < 10 ? '0' + n : '' + n
}

const QueueBar: React.FC<IProps> = ({ scene = 'menu' }) => {
  const { queueConfig, queueInfo } = queueMobx
  const [showDetail, setShowDetail] = useState(false)
  const [time, setTime] = useState('')

  const handleShow = (show: boolean) => {
    setShowDetail(show)
  }

  useEffect(() => {
    if (queueOrderingMobx.inPreQueueOrdering && showDetail) {
      let timeInterval: any
      if (timeInterval) clearInterval(timeInterval)
      const _getTime = () => {
        const cTime = ddayjs().valueOf()
        const aTime = ddayjs(queueInfo.status === 'Waiting' ? queueInfo.addTime : queueInfo.expireTime).valueOf()
        const inter = Math.abs(cTime - aTime)
        let second = Math.floor((inter) / 1000)
        second = second % 86400
        let hour = Math.floor(second / 3600)
        second %= 3600
        let minute = Math.floor(second / 60)
        second %= 60
        setTime(`${toM(hour)}:${toM(minute)}:${toM(second)}`)
      }
      _getTime()
      timeInterval = setInterval(_getTime, 1000)
      return () => {
        clearInterval(timeInterval)
      }
    }
  }, [queueOrderingMobx.inPreQueueOrdering, queueInfo.status, queueInfo.addTime, queueInfo.expireTime, showDetail])

  if (!queueOrderingMobx.inPreQueueOrdering) return null

  return (
    <div className={`queue-bar scene-${scene}`}>
      <div className='summary' onClick={() => handleShow(true)}>
        {queueInfo.status === 'Calling' ? i18n.t('queue.queueCalling', { table: queueInfo.tableAlias }) : i18n.t('queue.personAndTable', { person: queueInfo.person, count: (queueInfo.sort || 1) - 1 })}
        <Icon name='information' />
      </div>
      {
        showDetail ? (
          <div className='detail'>
            {
              queueInfo.status === 'Waiting' ? (
                <>
                  <div className='qd-time'>{i18n.t('queue.queueTime', { time: time })}</div>
                  <div className='qd-item'>{i18n.t('queue.rule2', { time: queueConfig.recallMin, count: queueConfig.recallPassSeat })}</div>
                </>
              ) : (
                <>
                  <div className='qd-time'>{i18n.t('queue.rule4', { time: time, count: queueConfig.recallPassSeat })}</div>
                </>
              )
            }
            <div className='qd-item'>{i18n.t('queue.rule3', { count: queueConfig.recallCnt })}</div>
            <div className='qd-up' onClick={() => handleShow(false)}>{i18n.t('cart.up')}</div>
          </div>
        ) : null
      }
    </div>
  )
}

export default observer(QueueBar)
